<template>
  <div class="after-sale">
    <card-m cardWidth="100%" cardHeight="100%" maxHeight="unset"
      :show-export="true"
      export-file-name="项目售后数据"
      @export="handleExport"
    >
      <template slot="card-title">
        <AppBreadcrumb page-name="项目售后" :list="breadcrumbList" />
      </template>

      <template slot="card-box">
        <div class="project-dashboard">
          <!-- 第一级：合同 -->
          <div class="left-panel">
            <contract-table
              tableId="afterSaleContractTable"
              :contractData="contractData"
              :currentContractKey="currentContractKey"
              :loading="contractLoading"
              @select="handleSelectContract"
            />
          </div>

          <!-- 第二级：售后编号 -->
          <div class="middle-panel">
            <after-sale-no-table
              tableId="afterSaleNoTable"
              :noList="currentAfterSaleNoList"
              :currentNo="currentAfterSaleNo"
              :loading="contractLoading"
              @select="handleSelectNo"
            />
          </div>

          <!-- 第三级：售后明细 -->
          <div class="right-panel">
            <service-and-pick
              tableId="afterSaleServicePick"
              :serviceList="currentServiceList"
              :pickList="currentPickList"
              :serviceTotalCount="currentServiceTotalCount"
              :pickTotalCount="currentPickTotalCount"
              :loading="detailLoading"
            />
          </div>
        </div>
      </template>
    </card-m>
  </div>
</template>



<script>
import contractTable from './contractTable.vue'
import afterSaleNoTable from './afterSaleNoTable.vue'
import serviceAndPick from './serviceAndPick.vue'
import { getAfterSaleInfoFromProject, getAfterSaleInfoFromNo } from '@/api/mainapi.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  components: { contractTable, afterSaleNoTable, serviceAndPick },
  data() {
    return {
      projectName: this.$route.params.projectName
        || sessionStorage.getItem('currentProjectName')
        || '',
      rawData: {},
      contractData: [],

      currentContractKey: '',
      currentAfterSaleNoList: [],   // ✅ 第二级
      currentAfterSaleNo: '',       // ✅ 当前编号

      // ✅ 后端数据没回来时表格转圈（与 contractProgress 的表格 loading 一致）
      contractLoading: false,       // 第一级：合同列表
      detailLoading: false,         // 第三级：服务 / 领料明细

      currentServiceTotalCount: 0,
      currentPickTotalCount: 0
    }
  },
computed: {
  currentServiceList() {
    const key = this.currentContractKey
    return (
      this.rawData[key] && this.rawData[key].serviceList
    ) || []
  },
  currentPickList() {
    const key = this.currentContractKey
    return (
      this.rawData[key] && this.rawData[key].pickList
    ) || []
  },
  // projectName() {
  //   // ✅ 1. EventBus（最快）
  //   if (window.__currentProjectName) {
  //     return window.__currentProjectName;
  //   }

  //   // ✅ 2. sessionStorage（刷新后）
  //   return sessionStorage.getItem('currentProjectName');
  // },
  projectNo() {
    return this.$route.params.projectNo || '';
  },
  /** ✅ 面包屑数据 */
  breadcrumbList() {
    return [
      {
        label: '项目主页',
        to: '/homepage/projects'
      },
      {
        label: this.projectName,
        tooltip: this.projectName,
        to: `/homepage/project/${this.projectNo}`
      },
      {
        label: '项目售后',
        tooltip: '项目售后',
        disabled: true
      }
    ];
  }
},  
  mounted() {
    this.fetch()
  },
  methods: {
    /** 清空三级联动数据和右侧明细 */
    resetAfterSaleData() {
      this.contractData = [];
      this.rawData = {};
      this.currentContractKey = '';
      this.currentAfterSaleNoList = [];
      this.currentAfterSaleNo = '';
      this.currentServiceTotalCount = 0;
      this.currentPickTotalCount = 0;
    },

    async fetch() {
      if (!this.projectName) {
        // ✅ 兜底：从 sessionStorage 读取
        const cachedName = sessionStorage.getItem('currentProjectName');
        if (cachedName) {
          this.projectName = cachedName;
        } else {
          this.$message.warning('未获取到项目名称')
          return
        }
      }

      this.contractLoading = true;
      try {
        const res = await getAfterSaleInfoFromProject({
           projectNo: this.projectNo ,
          // data: { cqcy_project: "XM20231207882"  },
          // data: { cqcy_project: "2022-5182"  },
          
          // pageSize: '9999',
          // pageNo: '1'
        })

        const payload = res.data && res.data.data;

        /* ⚠️ 空数据兜底：后端在没有数据时会返回 {"code":200,"data":"信息为空"}，
           注意这里的 data 是「字符串」而不是对象。
           原来的写法 `res.data.data || {}` 会让字符串进入后面的 Object.keys()，
           而 Object.keys('信息为空') === ['0','1','2','3'] →
           于是凭空多出 4 条假合同行（合同编号显示 0123）。 */
        const code = res.data && res.data.code;
        if (code !== 200 || !payload || typeof payload !== 'object' || Array.isArray(payload)) {
          this.resetAfterSaleData();
          this.$message.info('该项目暂无售后信息');
          return;
        }

        const data = payload;

        this.contractData = Object.keys(data)
          .filter(k => k !== '合同总条数')
          .map(key => {
            const contractInfo = data[key] || {}
            const pickList = contractInfo.pickNumList || []
            const serviceList = contractInfo.serviceNumList || []
            
            return {
              contractKey: key,
              contractNo: key.replace('售后信息：', ''),
              afterSaleNoList: [...pickList, ...serviceList]
            }
          })

        if (this.contractData.length) {
          this.handleSelectContract(this.contractData[0])
        } else {
          // 只有「合同总条数」这类非合同 key 时也会走到这里，顺手清空下游
          this.resetAfterSaleData()
          this.$message.info('该项目暂无售后信息')
        }

      } catch (err) {
        console.error(err)
        this.$message.error('获取项目售后信息失败')
      } finally {
        // 无论成功 / 失败 / 提前 return，都要关掉转圈
        this.contractLoading = false;
      }
    },

handleSelectContract(row) {
  this.currentContractKey = row.contractKey
  this.currentAfterSaleNoList = row.afterSaleNoList
  this.currentAfterSaleNo = ''

  var firstNo = row.afterSaleNoList && row.afterSaleNoList[0];
  if (firstNo && firstNo['编号']) {
    this.handleSelectNo(firstNo)
  }
},

    async handleSelectNo(row) {
      this.currentAfterSaleNo = row['编号']
      this.detailLoading = true;

      try {
        const res = await getAfterSaleInfoFromNo({
          id: row['编号'],
          pageSize: 100,
          pageNo: 1
        })

        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '获取售后信息失败')
          return
        }

        const data = res.data.data || {}

        // ✅ 存入 rawData，通过 computed 自动派生 currentServiceList / currentPickList
        this.$set(this.rawData, this.currentContractKey, {
          ...(this.rawData[this.currentContractKey] || {}),
          serviceList: data.serviceList || [],
          pickList: data.pickList || []
        })
        this.currentServiceTotalCount = Number(data['服务总条数'] || 0)
        this.currentPickTotalCount = Number(data['领料总条数'] || 0)

      } catch (e) {
        console.error(e)
        this.$message.error('获取售后信息失败')
      } finally {
        this.detailLoading = false;
      }
    },

    /** 导出Excel：三联表格合并为一个 Excel 文件，三个 sheet */
    handleExport() {
      const xlsxParam = { raw: true };
      const wb = XLSX.utils.book_new();

      // Sheet 1: 合同列表
      const contractEl = document.querySelector('#afterSaleContractTable');
      if (contractEl) {
        const contractSheet = XLSX.utils.table_to_sheet(contractEl, xlsxParam);
        XLSX.utils.book_append_sheet(wb, contractSheet, '合同列表');
      }

      // Sheet 2: 售后编号
      const noEl = document.querySelector('#afterSaleNoTable');
      if (noEl) {
        const noSheet = XLSX.utils.table_to_sheet(noEl, xlsxParam);
        XLSX.utils.book_append_sheet(wb, noSheet, '售后编号');
      }

      // Sheet 3: 服务/领料明细
      const detailEl = document.querySelector('#afterSaleServicePick');
      if (detailEl) {
        const detailSheet = XLSX.utils.table_to_sheet(detailEl, xlsxParam);
        XLSX.utils.book_append_sheet(wb, detailSheet, '售后明细');
      }

      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });

      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '项目售后数据.xlsx'
        );
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout);
        }
      }
      return wbout;
    }
  }
}
</script>


<style scoped lang="scss">
.project-dashboard {
  height: calc(100vh - 130px);
  display: grid;
  grid-template-columns: 1fr 3fr 4fr; // ✅ 三栏
  gap: 2px;
}

.left-panel,
.middle-panel,
.right-panel {
  height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>



